<template>
	<div
		class="video__ytb"
		@click="openModal"
	>
		<div
			class="video__ytb__img"
		>
			<img
				:src="image?.url"
				:width="image?.width"
				:height="image?.height"
				:alt="title||'Video Thumbnail'"
				class="img-fluid"
				ref="img"
				loading="lazy"
				decoding="async"
			>
		</div>

		<div class="video__ytb__title">{{ title }}</div>
	</div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import VideoYoutube from '../utils/video-youtube'

const props = defineProps({
	href: {
		type: String,
		required: true
	},
	title: {
		type: String,
	},
	thumbnailSize: {
		type: String,
		default: 'sddefault'
	}
})

const img = ref(null)
const ytb = new VideoYoutube(props.href)
const imageSource = ref(props.thumbnailSize)
const image = ref(null)
const iframe = ytb.createIframe()

// METHODS
function onImageError($event) {
	$event.target.style.border = '1px solid red'
}

function openModal() {
	VideoYoutube.modalBody.appendChild(iframe)
	VideoYoutube.modal.show()
}

// LIFE HOOKS
onMounted(() => {
	img.value.addEventListener('error', onImageError)

	image.value = ytb.thumbnails.filter(img => img.size == imageSource.value)[0]
})
</script>

<style lang="scss">

.video__ytb{
	position: relative;
	display: flex;
	flex-direction: column;
	gap: 15px;
	cursor: pointer;

	&:hover{
		--grayscale: 0;
	}
}

.video__ytb__img{
	position: relative;

	&::before {
		content: '';
		display: block;

		@supports (aspect-ratio: 16/9) {
			aspect-ratio: 16/9;
		}

		@supports not (aspect-ratio: 16/9) {
			padding-bottom: 56.25%;
		}
	}

	&::after {
		content: '';
		position: absolute;
		width: 68px;
		height: 48px;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
		background-size: 100%;
		background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 68 48"><path d="M66.52 7.74c-.78-2.93-2.49-5.41-5.42-6.19C55.79.13 34 0 34 0S12.21.13 6.9 1.55c-2.93.78-4.63 3.26-5.42 6.19C.06 13.05 0 24 0 24s.06 10.95 1.48 16.26c.78 2.93 2.49 5.41 5.42 6.19C12.21 47.87 34 48 34 48s21.79-.13 27.1-1.55c2.93-.78 4.64-3.26 5.42-6.19C67.94 34.95 68 24 68 24s-.06-10.95-1.48-16.26z" fill="red"/><path d="M45 24 27 14v20" fill="white"/></svg>');
		filter: var(--grayscale, grayscale(100%));
		transition: filter .2s ease-in-out;
	}

	img{
		position: absolute;
		widows: 100%;
		height: 100%;
		left: 0;
		top: 0;
		object-fit: cover;
	}
}

.video__ytb__title{
	font-weight: 800;
	color: #001F46;
}
</style>
